"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_4g(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "4g-hi"), /*#__PURE__*/React.createElement("g", {
    id: "4d2d75eb-6032-4a89-840e-dd3f27b6c345",
    "data-name": "4g-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "65a4f10e-cdf4-4d5c-a8e5-9c3eb4f0819b",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e2e220d-4cb8-4720-a59d-60cd43a4f5fc",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6ffe4a14-93fc-42b5-9dcf-e57ab3a106b9",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "956c8b25-774c-4a07-931a-7215330d9965",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c796cb87-7317-4129-a329-5c3f55704919",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5b43c1f9-ff4b-4abc-b7fc-551aa63aa089",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0614e861-bde5-45f7-a190-325055da4a33",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fa2a4588-1c9d-487f-83a1-880bf5295de2",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b3d8b7e1-1ea0-4824-af5c-37af9ab9e7e6",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f542e670-f5e2-46d0-a322-c9e61cdab347",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6b86df45-8ce9-42ee-9226-6223f2c70012",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a4c97fae-e507-4bcd-a511-c2332949fadc",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6600b707-3c6c-4a3e-850e-9bd6aa8f61fd",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7d147080-a2c2-49d0-9619-8e09b478c4d9",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a8665888-4f98-4e42-90bf-634ea9af8b4c",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18188978-9f3e-4a9d-bb4b-c5df9a8ed6a8",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eab64d12-c05d-4ea8-af46-4e8223cf8ffe",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ee720531-e0ff-49d0-aa68-e17914d645c1",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fe0c42c3-7154-4136-8e35-2d4339d9150a",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c909aacd-abce-4558-9df9-0517a4b93a02",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2ce35397-aeeb-4a9f-8d34-e8d76060f1ff",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8c03a4a2-e5ba-43b5-849d-50043812e6dc",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1293815c-33cb-4efc-a8d2-88662f86e94d",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6d5f75f0-da4f-4521-a044-b6c82f331638",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c57567d8-e4cb-483d-8fc0-df918a2acba2",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4b0e83b7-ce51-40b2-84c1-587d9a011edc",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "924b6532-b7e6-49c4-a429-28e937e4a6d5",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.25a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.25Z",
    transform: "translate(0 -0.25)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.32,126.5V114H42.73v-9.5l28.7-42h9.89V103h6.24v11H81.32V126.5ZM55.79,103H69.32V82.44Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85,127.84a29.21,29.21,0,0,1-11.47-2.21,24.38,24.38,0,0,1-9-6.48,30.14,30.14,0,0,1-5.81-10.42,43.9,43.9,0,0,1-2.06-14A45.12,45.12,0,0,1,97.74,79.8a30.7,30.7,0,0,1,6-10.46,23.69,23.69,0,0,1,8.59-6.19,26.36,26.36,0,0,1,10.22-2q8.26,0,13.54,3.12a21.05,21.05,0,0,1,8,8L135.56,80a15.89,15.89,0,0,0-3.07-3.89A13.66,13.66,0,0,0,128,73.46a15.23,15.23,0,0,0-5.38-1,11.87,11.87,0,0,0-8,3.07,17,17,0,0,0-5.09,8.3A38.47,38.47,0,0,0,108,94.72a29.21,29.21,0,0,0,2.59,12.72q2.59,5.42,6.43,7.2a17.74,17.74,0,0,0,7.49,1.78,35.62,35.62,0,0,0,6.19-.43,16.91,16.91,0,0,0,2.74-.62V103.84h-10v-11H145v30.82a27.76,27.76,0,0,1-7.87,2.88A56.34,56.34,0,0,1,123.85,127.84Z",
    transform: "translate(0 -0.25)",
    fill: "#e60000"
  }))))))))))))))))))))))))))))));
}

var _default = ic_4g;
exports.default = _default;